import request from '@/utils/request'

let BonusApi = {
  /*获取基础设置*/
  getData(data, errorback) {
    return request._get('/shop/plus.bonus.Setting/index', data, errorback);
  },
  /*保存基础设置*/
  saveData(data, errorback) {
    return request._post('/shop/plus.bonus.Setting/index', data, errorback);
  },
  /*获取分红记录*/
  getList(data, errorback) {
    return request._post('/shop/plus.bonus.Index/index', data, errorback);
  },
  /*获取分红详情*/
  detail(data, errorback) {
    return request._post('/shop/plus.bonus.Index/detail', data, errorback);
  },
  /*分红结算*/
  settlement(data, errorback) {
    return request._post('/shop/plus.bonus.Index/settlement', data, errorback);
  },
  /*分红结算*/
  grant(data, errorback) {
    return request._post('/shop/plus.bonus.Index/grant', data, errorback);
  },
}
export default BonusApi;



// WEBPACK FOOTER //
// ./src/api/plus/bonus.js